import { SEARCH_BY_BRAND_REQUEST, SEARCH_BY_BRAND_REQUEST_SUCCESS, SEARCH_BY_BRAND_REQUEST_FAILURE } from '../constants/search_by_brand.constants';

export const searchByBrandRequest = searchText => ({
    type: SEARCH_BY_BRAND_REQUEST,
    searchText,
});

export const searchByBrandRequestSuccess = payload => ({
    type: SEARCH_BY_BRAND_REQUEST_SUCCESS, payload,
});

export const searchByBrandRequestFailure = error => ({
    type: SEARCH_BY_BRAND_REQUEST_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/actions/search_by_brand.actions.js